import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterDataAPIv1 } from "services/CRUDServices";
import { filterUrls } from "services/api.enums";

export const filterTerminalHistory: AsyncThunk<{}, {}, {}> =
  createAsyncThunk("terminalHistory", async (body: any) => {
    // delete body.pageNumber
    const data = await filterDataAPIv1(
            `/core-api/terminalHistory/filetr/id`,
        {
          terminalId: body.id,
        },
        body.pageNumber || 1,
        10,
        [
          {
            property: "id",
            direction: "DESC",
          },
        ],
        "POST"
      );

    return data.data;
  });

const initialState: any = {
  terminalHistoryData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const TerminalHistorySlice = createSlice({
  initialState: initialState,
  name: "terminalHistory",
  reducers: {
    clearTerminal: (state) => {
      state.terminalHistoryData = [];
    },
    setFilterTerminal: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterTerminalHistory.fulfilled as any]: (state, action) => {
      state.terminalHistoryData = action.payload;
      state.fetchpost = false;
    },
    [filterTerminalHistory.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterTerminalHistory.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterTerminal, clearTerminal } =
  TerminalHistorySlice.actions;
export default TerminalHistorySlice.reducer;
